import React, {Component} from "react";

class Loading extends Component {
	render() {
		return (
			<div className="line-widget-loader">
				<div className="spinner-eff spinner-eff-3">
					<div className="circle circle-1"></div>
					<div className="circle circle-2"></div>
					<div className="circle circle-3"></div>
				</div>
			</div>
		);
	}
}

export default Loading;


// WEBPACK FOOTER //
// ./src/app/components/LineWidget/Loading.js